/** Internal next.js route; locale middleware handles localized paths (e.g. ar → دردشة). */
export const CHAT_EMBED_PATHNAME = "chat/embed";

export interface ChatEmbedUrlInput {
  origin: string;
  locale: string;
  chatId: string;
  guestToken?: string | null;
}

/** Build absolute chat embed URL using the URL API (no string concatenation). */
export function buildChatEmbedUrlFromParts({ origin, locale, chatId, guestToken }: ChatEmbedUrlInput): string {
  const url = new URL(`/${locale}/${CHAT_EMBED_PATHNAME}`, origin);
  url.searchParams.set("chatId", chatId);
  url.searchParams.set("embed", "meet");
  url.searchParams.set("hideList", "true");
  url.searchParams.set("hideCalls", "true");
  if (guestToken?.trim()) {
    url.searchParams.set("guestToken", guestToken.trim());
  }
  return url.href;
}

/** Resolve a valid http(s) origin from the first usable env value. */
export function resolveOriginFromEnvValues(...values: Array<string | undefined | null>): string | null {
  for (const raw of values) {
    const trimmed = raw?.trim();
    if (!trimmed) continue;
    try {
      return new URL(trimmed).origin;
    } catch {
      continue;
    }
  }
  return null;
}
